import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldAlert } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/withdrawals`;

export const AdminWithdrawals = ({ adminKey }) => {
  const [rows, setRows] = useState(null);
  const headers = { 'X-Admin-Key': adminKey };
  const load = useCallback(() => axios.get(API, { headers: { 'X-Admin-Key': adminKey } }).then((r) => setRows(r.data.rows)).catch(() => setRows([])), [adminKey]);
  useEffect(() => { if (adminKey) load(); }, [adminKey, load]);

  const act = async (id, path, params) => {
    try { await axios.post(`${API}/${id}/${path}`, null, { headers, params }); toast.success(path === 'reject' ? 'Rejected — balance returned' : 'Marked paid'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };
  if (!rows) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid="admin-withdrawals">
      <div className="mb-2 flex items-center gap-2"><ShieldAlert className="h-4 w-4 text-amber-600" /><h3 className="text-sm font-bold text-slate-900">Withdrawal review queue</h3>
        <span className="text-xs text-slate-500">Nothing is paid out automatically. Reject anything without verified real funding.</span></div>
      {rows.length === 0 ? <p className="text-sm text-slate-500" data-testid="admin-withdrawals-empty">No withdrawals waiting.</p> : rows.map((r) => (
        <div key={r.id} className="flex flex-wrap items-center gap-3 border-t border-slate-100 py-2 text-xs" data-testid={`admin-withdrawal-${r.id}`}>
          <span className="font-mono">{r.reference}</span>
          <span className="font-semibold">TZS {Number(r.amount).toLocaleString()}</span>
          <span>{r.bank_name} · {r.account_number}</span>
          <span className={r.has_real_funding ? 'text-emerald-700' : 'font-semibold text-red-600'} data-testid={`admin-withdrawal-funding-${r.id}`}>
            {r.has_real_funding ? 'backed by real deposits' : 'NO real funding (demo balance)'}</span>
          <span className="text-slate-500">{new Date(r.created_at).toLocaleString()}</span>
          <div className="ml-auto flex gap-2">
            <button onClick={() => act(r.id, 'reject')} className="rounded-lg border border-red-300 px-2 py-1 font-semibold text-red-700" data-testid={`admin-withdrawal-reject-${r.id}`}>Reject</button>
            {r.has_real_funding && <button onClick={() => { const ref = window.prompt('Payout reference (bank/Selcom)'); if (ref) act(r.id, 'approve', { payout_reference: ref }); }}
              className="rounded-lg bg-emerald-700 px-2 py-1 font-semibold text-white" data-testid={`admin-withdrawal-approve-${r.id}`}>Mark paid</button>}
          </div>
        </div>
      ))}
    </div>
  );
};
